import { render } from "./providerProfile.vue?vue&type=template&id=ca9a2d50&ts=true"
import script from "./providerProfile.vue?vue&type=script&lang=ts"
export * from "./providerProfile.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__